function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 5,
  fill: "#4CAF50"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.285 13.581c-.375-2.903-2.784-5.19-5.837-5.538A7.352 7.352 0 0017.656 8c-2.699.004-5.129 1.555-6.155 3.93-1.026 2.374-.446 5.102 1.469 6.911a4.882 4.882 0 011.618 3.548v.733h6.153v-.737a4.771 4.771 0 011.561-3.49c1.5-1.378 2.235-3.345 1.983-5.314z",
  fill: "#4CAF50"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.285 13.581c-.375-2.903-2.784-5.19-5.837-5.538A7.352 7.352 0 0017.656 8c-2.699.004-5.129 1.555-6.155 3.93-1.026 2.374-.446 5.102 1.469 6.911a4.882 4.882 0 011.618 3.548v.733h6.153v-.737a4.771 4.771 0 011.561-3.49c1.5-1.378 2.235-3.345 1.983-5.314z",
  fill: "#fff",
  fillOpacity: 0.9
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.665 28c.652 0 1.232-.391 1.45-.976h-2.9c.218.585.798.975 1.45.976z",
  fill: "#4CAF50"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.665 28c.652 0 1.232-.391 1.45-.976h-2.9c.218.585.798.975 1.45.976z",
  fill: "#fff",
  fillOpacity: 0.9
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1 25.56c.001.27.23.488.513.489h4.102a.501.501 0 00.513-.488v-1.463h-5.127v1.463z",
  fill: "#4CAF50"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1 25.56c.001.27.23.488.513.489h4.102a.501.501 0 00.513-.488v-1.463h-5.127v1.463z",
  fill: "#fff",
  fillOpacity: 0.9
});

function SvgSuggestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgSuggestion;